<template>
  <div class="live-item" :style="item.listImg && `background-image: url(${item.listImg})`" @click="itemClick">
    <div class="item-content">
      <div class="preview-box">
        <notice-tag :title="title" :content="content" bgImage="linear-gradient(131deg, #A2B3CD 0%, #6A87B2 97%)"></notice-tag>

        <img
          class="icon-nav"
          v-if="item.showType"
          :src="item.showType === 1 ?
            require('../../assets/images/icon-video.png') :
            require('../../assets/images/icon-broadcast.png')
          "
          alt="壹心理直播"
        />
      </div>
      <div class="bottom-con">
        <info-con :img-src="item.channelAvatar" :title="item.channelName" :subheading="item.title"></info-con>
      </div>
    </div>
  </div>
</template>

<script>
  import NoticeTag from 'components/NoticeTag'
  import InfoCon from 'components/InfoCon'
  import { formatDecimal } from 'utils/utils'

  export default {
    name: "ReplayItem",
    components: {
      NoticeTag,
      InfoCon
    },
    props: {
      item: {
        type: Object,
        default: ()=>{}
      }
    },
    data() {
      return {
        title: '回放'
      }
    },
    computed: {
      content() {
        if (!this.item.playNum) return ''
        if (this.item.playNum < 10000) {
          return `${this.item.playNum}观看`
        } else {
          return `${formatDecimal(this.item.playNum/10000, 1)}万观看`
        }
      }
    },
    methods: {
      itemClick() {
        this.$emit('itemClick', this.item)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";

  .live-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    position: relative;
    width: 330px;
    height: 482px;

    overflow: hidden;
    border-radius: 10px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .bottom-con {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .preview-box {
    position: absolute;
    left: 16px;
    top: 16px;
    right: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 26px;
    overflow: hidden;
    color: #fff;
    .icon-nav {
      display: block;
      width: 26px;
      height: 26px;
    }
  }
</style>
